import { useQuery } from '@tanstack/react-query';
import api from '../services/api';
import { API_ROUTES } from '../config/api';
import { LifecycleRecord, PaginatedResponse } from '../types/api.types';

export interface UseLifecyclesListOptions {
  page?: number;
  pageSize?: number;
  articleIds?: string[];
  enabled?: boolean;
}

/**
 * Hook to fetch paginated list of all lifecycle records for a database
 * Uses GET /list/ endpoint with pagination support
 */
export function useLifecyclesList(
  databaseId: number | string | null,
  options?: UseLifecyclesListOptions
) {
  const { page = 1, pageSize = 50, articleIds, enabled = true } = options || {};

  return useQuery<PaginatedResponse<LifecycleRecord>>({
    queryKey: ['lifecyclesList', databaseId, page, pageSize, articleIds],
    queryFn: async () => {
      if (!databaseId) {
        throw new Error('Database ID is required');
      }

      const params: any = {
        page,
        page_size: pageSize,
      };

      // Add article_ids filter if provided
      if (articleIds && articleIds.length > 0) {
        params.article_ids = articleIds.join(',');
      }

      // Use GET /list/ endpoint with pagination
      // The endpoint is /life-cycle/{database_id}/list/
      const response = await api.get(
        `${API_ROUTES.LIFE_CYCLE.BASE}/${databaseId}/list/`,
        { params }
      );

      return response.data;
    },
    enabled: !!databaseId && enabled,
    staleTime: 1000 * 60 * 5, // Consider data fresh for 5 minutes
  });
}

